// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2b-6";
export var headerCell = "_2b-2";
export var rowWrapper = "_2b-4";
export var stickyAggregationCell = "_2b-a";
export var stickyAggregationRow = "_2b-7";
export var stickyColumnCell = "_2b-9";
export var stickyColumnHeaderCell = "_2b-8";
export var table = "_2b-1";
export var virtualRowWrapper = "_2b-5";
export var virtualTableContainer = "_2b-0";
export var white = "_2b-3";